import React, {Fragment} from "react";
import {withRouter} from "react-router-dom";
import MainPanelComponent from "./MainPanelComponent";
import SidePanelComponent from "./SidePanelComponent";
import SFXButtonComponent from "./SFXButtonComponent";
import {Col, Form, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import CreateObjectRowWithLabelComponent from "./CreateObjectRowWithLabelComponent";
import DataTableComponent from "./DataTableComponent";
import ToastHelper from "../utils/ToastHelper";
import CardBatchService from "../services/card/stock/CardBatchService";
import UserService from "../services/admin/UserService";
import UserSessionService from "../services/UserSessionService";
import DropdownComponent from "./DropdownComponent";

const COLUMN_CONFIG = (isDeleteHidden) => [
    {
        dataField: "id",
        header: "Id",
        hidden: true
    },
    {
        dataField: "barcode",
        header: "Barcode"
    },
    {
        dataField: "button",
        header: "",
        type: "button",
        buttonText: "Delete",
        width: "75px",
        hidden: isDeleteHidden
    }
];

class BankCardAssignmentComponent extends React.Component {
    constructor(props) {
        super(props);

        this.userId = UserSessionService.getUser().user.id;

        this.state = {
            scannedBarcode: "",
            scannedBarcodes: [],
            tableData: [],
            howModal: false,
            modalTitle: "",
            modalMessage: "",
            agents: [],
            assignedToUserId: 0,
        };
    }

    componentDidMount() {
        UserService.retrieveManagedUsers(this.userId).then(response => {
            if (Array.isArray(response)) {
                this.setState({
                    agents: response
                })
            } else {
                ToastHelper.formatError(response);
            }
        });
    }

    onAssignClick() {
        let bankCardUserAssignmentRequest = {};
        bankCardUserAssignmentRequest.assignedToUserId = this.state.assignedToUserId;
        bankCardUserAssignmentRequest.bankCardBarcodes = this.state.scannedBarcodes;

        CardBatchService.assignCardsToUser(this.props.batchId, bankCardUserAssignmentRequest).then(response => {
            if (response.id) {
                this.props.loadData();
                this.props.btnBackClick();
                ToastHelper.success("Bank Cards Assigned Successfully.")
            } else {
                ToastHelper.formatError(response);
            }
        });
    }

    onFormSubmit(e) {
        if (e.preventDefault) {
            e.preventDefault();
        }

        let scannedBarcode = e.target['input'].value;

        if (!this.props.barcodes.includes(scannedBarcode)) {
            this.setState({
                showModal: true,
                modalTitle: "Bank Card Not Added",
                modalMessage: "This bank card does not belong to this batch: " + scannedBarcode
            });
        } else if (this.state.scannedBarcodes.includes(scannedBarcode)) {
            this.setState({
                showModal: true,
                modalTitle: "Bank Card Already Added",
                modalMessage: "This bank card has already been added: " + scannedBarcode
            });
        } else {
            let scannedBarcodes = [
                scannedBarcode,
                ...this.state.scannedBarcodes
            ];

            let tableData = this.createTableDataForScannedBarcodes(scannedBarcodes);

            this.setState({
                scannedBarcodes: scannedBarcodes,
                scannedBarcode: "",
                tableData: tableData
            });
        }
    }

    createTableDataForScannedBarcodes(barcodesArr) {
        let tableData = []
        barcodesArr.map((singleBarcode, index) => {
            tableData.push({id: index, barcode: singleBarcode});
            return singleBarcode;
        });

        return tableData;
    }

    handleDeleteClick(item) {
        let scannedBarcodes = this.state.scannedBarcodes;
        let index = scannedBarcodes.indexOf(item.barcode);
        scannedBarcodes.splice(index, 1);

        let tableData = this.createTableDataForScannedBarcodes(scannedBarcodes);

        this.setState({
            scannedBarcodes: scannedBarcodes,
            tableData: tableData
        });
    }

    onClose() {
        this.setState({
            showModal: false,
            scannedBarcode: ""
        });
    }

    handleDropdownChange(option) {
        this.setState({
            assignedToUserId: option === null ? 0 : option.id
        });
        document.getElementById("input").focus();
    }

    render() {
        return <Fragment>
            <MainPanelComponent>

                <Row style={{marginBottom: "1em"}}>
                    <Col>
                        <CreateObjectRowWithLabelComponent label={"Agent"}>
                            <DropdownComponent
                                options={this.state.agents}
                                optionValue={"id"}
                                optionText={"fullName"}
                                placeholder={"Select User"}
                                onChange={(selectedOptions) => {
                                    this.handleDropdownChange(selectedOptions)
                                }}
                            />
                        </CreateObjectRowWithLabelComponent>

                        <CreateObjectRowWithLabelComponent label={"Barcode"}>
                            <Form
                                onSubmit={(e) => {
                                    this.onFormSubmit(e)
                                }}
                            >
                                <Input id='input' type={"text"} value={this.state.scannedBarcode}
                                       placeholder={"Barcode"}
                                       onChange={(e) => {
                                           this.setState({scannedBarcode: e.target.value})
                                       }}
                                />
                            </Form>
                        </CreateObjectRowWithLabelComponent>
                    </Col>
                </Row>


                <DataTableComponent
                    tableColumnConfig={COLUMN_CONFIG(false)}
                    tableData={this.state.tableData}
                    search={true}
                    pagination={false}
                    onButtonClick={(columnKey, item) => {
                        this.handleDeleteClick(item);
                    }}
                />

                {this.state.showModal && this.renderModal()}

            </MainPanelComponent>

            <SidePanelComponent>
                <Fragment>
                    <SFXButtonComponent onClick={this.onAssignClick.bind(this)} className={"btn btn-sfx-primary"}
                                        style={{width: '100%', marginBottom: '5px'}}
                                        disabled={this.state.scannedBarcodes.length <= 0 || this.state.assignedToUserId === 0}
                    >
                        Assign Cards
                    </SFXButtonComponent>

                    {'   '}
                    <SFXButtonComponent onClick={this.props.btnBackClick} className={"btn btn-sfx-secondary"}
                                        style={{width: '100%', marginBottom: '5px'}}>
                        Cancel
                    </SFXButtonComponent>
                </Fragment>
            </SidePanelComponent>
        </Fragment>
    }

    renderModal() {
        return <Fragment>
            <Modal isOpen={true} className={'modal-primary modal-md'}>
                <ModalHeader toggle={this.toggle}>{this.state.modalTitle}</ModalHeader>
                <ModalBody>
                    <Fragment>
                        {this.state.modalMessage}
                    </Fragment>
                </ModalBody>
                <ModalFooter>
                    <SFXButtonComponent color="secondary" onClick={this.onClose.bind(this)}>Close</SFXButtonComponent>
                </ModalFooter>
            </Modal>
        </Fragment>
    }
}

export default withRouter(BankCardAssignmentComponent);
